import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FinancialProfileGuard } from 'src/app/core/guards/onboarding/financial-profile.guard';
import { DocumentTypeResolver } from 'src/app/core/resolvers/onboarding/financial-profile/document-type.resolver';
import { InvoiceAmountResolver } from 'src/app/core/resolvers/onboarding/financial-profile/invoice-amount.resolver';
import { InvoiceTermResolver } from 'src/app/core/resolvers/onboarding/financial-profile/invoice-term.resolver';
import { PageStateClientPersonalizedResolver } from 'src/app/core/resolvers/onboarding/navigation/page-state-client-personalized.resolver';
import { PageStateResolver } from 'src/app/core/resolvers/onboarding/navigation/page-state.resolver';
import { ApStatementsComponent } from './ap-statements/ap-statements.component';
import { ArStatementsComponent } from './ar-statements/ar-statements.component';
import { BalanceSheetsComponent } from './balance-sheets/balance-sheets.component';
import { BankStatementsComponent } from './bank-statements/bank-statements.component';
import { InvoiceAmountComponent } from './invoice-amount/invoice-amount.component';
import { InvoiceTermComponent } from './invoice-term/invoice-term.component';
import { PlStatementsComponent } from './pl-statements/pl-statements.component';
import { SummaryComponent } from './summary/summary.component';

const routes: Routes = [
  {
    path: 'invoice-amount',
    component: InvoiceAmountComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: InvoiceAmountResolver,
    },
    canActivate: [FinancialProfileGuard],
  },
  {
    path: 'invoice-term',
    component: InvoiceTermComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      options: InvoiceTermResolver,
    },
    canActivate: [FinancialProfileGuard],
  },
  {
    path: 'files',
    component: BalanceSheetsComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      documentType: DocumentTypeResolver,
    },
    canActivate: [FinancialProfileGuard],
  },
  {
    path: 'bank-statements',
    component: BankStatementsComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      documentType: DocumentTypeResolver,
    },
    canActivate: [FinancialProfileGuard],
  },
  {
    path: 'pl-statements',
    component: PlStatementsComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      documentType: DocumentTypeResolver,
    },
    canActivate: [FinancialProfileGuard],
  },
  {
    path: 'ar-statements',
    component: ArStatementsComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      documentType: DocumentTypeResolver,
    },
    canActivate: [FinancialProfileGuard],
  },
  {
    path: 'ap-statements',
    component: ApStatementsComponent,
    resolve: {
      data: PageStateClientPersonalizedResolver,
      documentType: DocumentTypeResolver,
    },
    canActivate: [FinancialProfileGuard],
  },
  {
    path: 'summary',
    component: SummaryComponent,
    resolve: { data: PageStateClientPersonalizedResolver },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [PageStateResolver],
})
export class FinancialProfileRoutingModule {}
